import { ca } from '@cian/analytics';

export const trackOpenDesktopListing = () => {
  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'ListingHybrid',
      siteType: 'desktop',
    },
  });
};

export const trackCloseDesktopListing = () => {
  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'Map',
      siteType: 'desktop',
    },
  });
};
